export default {
  composition: {
    printPlates: {}
  },
  orderData: {}
};
